<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pengaturan Akun</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="font-weight-bold text-createstaff">

                    </div>
                    <div class="set-small-text color-33333 mar-bot-12">
                        Berikut adalah data login karyawan Anda untuk dapat masuk di aplikasi kasir atau produksi
                    </div>
                    <form action="">
                        <div class="form-group">
                            <div>
                                <label class="remove-margin require" for="usernamesetakun">Username</label>
                                <input type="text" class="form-control inputs" id="usernamesetakun"
                                       aria-describedby="emailHelp" placeholder="EX:Harmania_Sidoarjo19" v-model="editusername" v-on:keyup="inputusername">
	                            <ErrorMessage class="error" label="Username" :validation="$v.editusername"></ErrorMessage>
                            </div>
                            <div id="show" class="color-206CF font-weight-600 line-height-25 letter-space-002 mar-top-16" @click="showpassword">Ubah Kata Sandi</div>
                            <div id="hide" class="color-EB5757 font-weight-600 line-height-25 letter-space-002 mar-top-16" @click="hidepassword"><span class="mar-right-10"><img
                                    src="../../assets/icons/close.svg" alt=""></span>Batalkan Ubah Kata sandi</div>
                            <div id="passwordsetakun">
                              <div>
                                <label class="remove-margin require mar-top-12" for="passwordsetpass">Password</label>
                                <input type="password" class="form-control inputs" id="passwordsetpass" @keyup="listenCapslock($event, 'passwordsetpass')"
                                       aria-describedby="emailHelp" placeholder="EX:sidoarjo19H" v-model="editpassword" v-on:keyup="inputpass">
                                <span toggle="#password-field1" id="password-field1" v-on:click="changeViewPass1"
                                      class="fa fa-eye field-icon toggle-password"></span>
                                <div class="font-12 text-small mar-top-5">Minimal 8 karakter dengan kombinasi huruf dan angka</div>
	                              <ErrorMessage class="error" label="Password" :validation="$v.editpassword"></ErrorMessage>
                              </div>
                              <div>
                                <label class="remove-margin require mar-top-12" for="confirmpasswordsetakun">Password</label>
                                <input type="password" class="form-control inputs" id="confirmpasswordsetakun" @keyup="listenCapslock($event, 'confirmpasswordsetakun')"
                                       aria-describedby="emailHelp" placeholder="EX:sidoarjo19H" v-model="confirmpassword" v-on:keyup="inputconpass">
                                <span toggle="#password-field2" id="password-field2" v-on:click="changeViewPass"
                                      class="fa fa-eye field-icon toggle-password"></span>
	                              <ErrorMessage class="error" label="Password" :validation="$v.confirmpassword"></ErrorMessage>
                              </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" :disabled="!validateAccess('account.update')" id="btnNext" @click="ubahdataakun">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textBtn2">Simpan</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, sameAs, required} from "vuelidate/lib/validators";

    export default {
        name: "AkunSet",
        props:['setidkaryawan'],
	    components: { ErrorMessage },
        data(){
            return{
                idkaryawan:this.setidkaryawan,
                editusername:'',
                editpassword:'',
                confirmpassword:'',
                statuspassordakun:'0',
                isClicked:false,
                isClickedloader:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    editusername: {
		    	required,
			    minLength: minLength(2)
		    },
		    editpassword: {
		    	required,
			    minLength: minLength(8),
		    },
		    confirmpassword: {
		    	required,
			    minLength: minLength(8),
			    sameAsPassword: sameAs("editpassword")
		    }
	    },
        mounted(){
            this.cekvalidasi();
            this.idkaryawan = this.$route.params.idkaryawan
            // this.smartTrackingView("pengaturan_akun_karyawan",{"idkaryawan":this.idkaryawan});

        },
        methods:{
            back(){
                $('#show').show()
                $('#hide').hide()
                this.$emit("isdetail")
            },
            showpassword(){
                $('#show').hide()
                $('#hide').show()
                $('#passwordsetakun').show()
                this.statuspassordakun ='1'
                this.cekvalidasi()
            },

            hidepassword(){
                $('#passwordsetakun').hide()
                $('#show').show()
                $('#hide').hide()
                this.statuspassordakun ='0'
                this.cekvalidasi()
            },

            changeViewPass1(event) {
                if ($('#passwordsetpass').attr("type") == "password") {
                    $('#password-field1').removeClass('fa fa-eye');
                    $('#password-field1').addClass('fa fa-eye fa-eye-slash');
                    $('#passwordsetpass').attr("type", "text");
                } else {
                    $('#password-field1').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field1').addClass('fa fa-eye');
                    $('#passwordsetpass').attr("type", "password");
                }
            },

            changeViewPass(event) {
                if ($('#confirmpasswordsetakun').attr("type") == "password") {
                    $('#password-field2').removeClass('fa fa-eye');
                    $('#password-field2').addClass('fa fa-eye fa-eye-slash');
                    $('#confirmpasswordsetakun').attr("type", "text");
                } else {
                    $('#password-field2').removeClass('fa fa-eye fa-eye-slash');
                    $('#password-field2').addClass('fa fa-eye');
                    $('#confirmpasswordsetakun').attr("type", "password");
                }
            },

            inputpass(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.editpassword = number;
                this.cekvalidasi()
                // this.combinationpass()

            },

            inputconpass(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z]+/, '');
                this.confirmpassword = number;
                this.cekvalidasi();
                // this.combinationconpass();
            },

            inputusername(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z.,'-]+/, '');
                this.editusername = number;
                this.cekvalidasi()
            },

            combinationpass(){
                if(this.editpassword !== '') {
                    var numeric = /[0-9]/;
	                var alphabeth = /[A-Za-z]/;
                    if(!numeric.test(this.editpassword) || !alphabeth.test(this.editpassword)) {
                        // $('#btnNext').prop('disabled', true);
                        return true;
                    }
                }else {
                    return false
                }

            },

            combinationconpass(){
                if(this.confirmpassword !== '') {
	                var numeric = /[0-9]/;
	                var alphabeth = /[A-Za-z]/;
                    if(!numeric.test(this.confirmpassword) || !alphabeth.test(this.confirmpassword)) {
                        // $('#btnNext').prop('disabled', true);
                        return true;
                    }
                }else {
                    return false
                }

            },

            cekvalidasi(){
            	return
                var staffusername = this.editusername;
                var staffpass = this.editpassword;
                var staffconfirmpass = this.confirmpassword;
                var stringstaffpass = staffpass.toString();
                var stringconfpass = staffconfirmpass.toString()
                var lenPass = staffusername.length;
                if(this.statuspassordakun==='0') {
                    if (lenPass >= 2) {
                        $('#btnNext').prop('disabled', false);
                    } else {
                        $('#btnNext').prop('disabled', true);
                    }
                }else if(this.statuspassordakun==='1'){
                    if (lenPass >= 2 && (stringstaffpass.length >= 8) && (stringconfpass.length >=8)) {
                        $('#btnNext').prop('disabled', false);
                    } else {
                        $('#btnNext').prop('disabled', true);
                    }
                }else{
                    $('#btnNext').prop('disabled', true);
                }
            },

            async getakun() {
                // this.isClickedloader = true;
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_karyawan_meta?idkaryawan=' + this.setidkaryawan, this.requestHeaders)
                    this.karyawan = response.data.data
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var res = response.data.data
                            this.editusername= res.email,
                            // this.editpassword= res.password_plain;
                            $('#passwordsetakun').hide()
                            $('#hide').hide()
                        }
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        // this.isClicked = false;
                        this.cekvalidasi()
                    }
                    // $('#loadingPage').removeClass('overlayLoading');
                    // this.isClickedloader = false;
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

	        errorValidation() {
            	if (this.statuspassordakun === '1') {
		            this.$v.editusername.$touch()
		            this.$v.editpassword.$touch()
		            this.$v.confirmpassword.$touch()
            		return this.$v.editusername.$invalid || this.$v.editpassword.$invalid || this.$v.confirmpassword.$invalid
	            }
		        this.$v.editusername.$touch()
		        return this.$v.editusername.$invalid
	        },
            async ubahdataakun(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
            	if (this.combinationconpass() && this.combinationpass()) {
		            this.$toast.error("Password harus mengandung kombinasi huruf dan angka")
            		return
	            }
                var matchpass = this.editpassword;
                const ubahakun = new FormData();
                if(this.statuspassordakun==='1') {
                    if (matchpass !== this.confirmpassword || matchpass === '') {
                    	this.$toast.error('Password Not Match')
                        return
                    }else{
                        ubahakun.append('password', this.editpassword);
                    }
                }
                this.isClicked = true;
                $('#textBtn2').hide()
                $('#btnNext').prop('disabled', true);
                try {
                    ubahakun.append('username', this.editusername);
                    ubahakun.append('status_password', this.statuspassordakun)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/update_pengaturan_akun?idkaryawan=' + this.setidkaryawan, ubahakun,this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.back()
                            this.isClicked = false;
                            $('#textBtn2').show();
                            $('#btnNext').prop('disabled', false);
                            this.$toast.success(response.data.msg)
	                        this.hidepassword()
	                        this.editpassword = ""
	                        this.confirmpassword = ""
                        }else{
                        	this.$toast.error(response.data.msg)
                            this.isClicked = false;
                            $('#textBtn2').show();
                            $('#btnNext').prop('disabled', false);
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtn2').show();
	                $('#btnNext').prop('disabled', false);
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }

                this.smartTrackingClick("simpan_pengaturan_akun_karyawan",{"idkaryawan":this.idkaryawan});

            }
        }
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }
</style>